import React, { useState, useEffect } from "react";
import { Row, Table,Col,Button, CardBody,Card } from "reactstrap";
import {
  useGetFarmerByIdQuery,
  useGetImagePathByIdQuery,
} from "./farmerApiSlice";
import { useParams,useLocation } from "react-router-dom";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import Pages404 from "./Pages404";
import FarmerNoResponse from "./FarmerNoResponse";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const FarmerDocuments = ({ tabIndex, data, refetch }) => {
  const { id } = useParams();
    const location = useLocation();
  
  const [sendImagePath, setImagePath] = useState("");
  // const { data: data ,refetch:refetchFarmerData} = useGetFarmerByIdQuery(id);
  const { data: pathImage } = useGetImagePathByIdQuery(sendImagePath);
  const [DocumentList, setDocumentList] = useState([]);
  const [openLightbox, setOpenLightBox] = useState(false);
  const [lightBoxViewImage, setImageInLightbox] = useState("");
  const [showLoader, setLoaderMain] = useState(false);
  const fullname = location.state?.fullname || "";

  useEffect(() => {
    // refetchFarmerData();
    const userFromApi = data?.data ? data?.data : DocumentList;
    if (userFromApi.media !== undefined) setDocumentList(userFromApi.media);
  }, [tabIndex]);
  // useEffect(() => {
  //   const userFromApi = data?.data ? data?.data : DocumentList;
  //   if (userFromApi.media !== undefined) setDocumentList(userFromApi.media);
  // }, [tabIndex,data]);
  const showLargeImage = (imagePath) => {
    setImagePath(imagePath);
    setOpenLightBox(true);
  };
  useEffect(() => {
    if (pathImage) setImageInLightbox(pathImage.data.url);
  }, [pathImage]);
  const ReloadApplication = () => {
    setLoaderMain(true);
    setTimeout(() => {
      refetch();
      setLoaderMain(false);
    }, 1500);
  };
  return (
    <>
       <div
            className="d-flex justify-content-between align-items-center headerStyleCard" 
            style={{ borderRadius: "5px" }}
          >
            <h5 className="textgrey m-0 text-capitalize">
              {fullname}
              
            </h5>
            <Col md="2">
              <Button
            className="bg-transparent text-black fs-6 mx-2 reloadButton float-end"
                size="sm"
                onClick={ReloadApplication}
              >
                Reload&nbsp; &nbsp;
                <FontAwesomeIcon icon={faRotateLeft} />
              </Button>
            </Col>
          </div>
      {DocumentList.length === 0 ? (
        <FarmerNoResponse />
      ) : (
        <>
        
          <div className="d-lg-block d-md-none d-none">
          <Card>
      <CardBody className="p-2">
            <div className="p-2">
              {DocumentList && DocumentList.length > 0 ? (
                <>
                  {DocumentList.map((item, index) => (
                    <div
                      key={index}
                      className="mb-4 p-3 border rounded shadow-sm"
                    >
                      <Table
                        responsive
                        bordered
                        hover
                        className="custom-border-table"
                      >
                        <thead>
                          <tr className="bg-secondary2 text-white text-center">
                            <th>File Name</th>
                            <th>Category</th>
                            <th>Media Type</th>
                            <th>File Type</th>
                            <th>View</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.document_types
                            .flatMap((innerItem) => innerItem.documents)
                            .map((data, docIndex) => (
                              <tr key={docIndex} className="text-center">
                                <td>
                                  <i className="mdi mdi-file-document-multiple fs-5 text-warning"></i>
                                  &nbsp;
                                  {data.filename}
                                </td>
                                <td>
                                  {data.media_category.replace(/_/g, " ")}
                                </td>
                                <td
                                  style={{ color: "#1976D2" }}
                                  className="f14 font600"
                                >
                                  {data.media_type.replace(/_/g, " ")}
                                </td>
                                <td>{data.file_type}</td>
                                <td>
                                  <i
                                    className="mdi mdi-eye fs-5 text-warning cursor-pointer"
                                    onClick={() => showLargeImage(data.path)}
                                  ></i>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>

                      <div className="mt-4">
                        <hr
                          className="my-3"
                          style={{
                            borderTop: "2px solid #ddd",
                            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
                  <h5>No Data Available</h5>
                </div>
              )}
            </div>

            {openLightbox && (
              <Lightbox
                image={lightBoxViewImage}
                title="Image Title"
                onClose={() => setOpenLightBox(false)}
              />
            )}
            </CardBody>
            </Card>
          </div>
          <div className="d-lg-none d-md-none d-block p-2">
            {DocumentList && DocumentList.length > 0 ? (
              <>
                {DocumentList.map((item, index) => (
                  <div key={index} className="">
                    <div className="d-flex flex-column gap-2">
                      {item.document_types
                        .flatMap((innerItem) => innerItem.documents)
                        .map((data, docIndex) => (
                          <div
                            key={docIndex}
                            className="card shadow-sm mb-3 p-3 rounded-3 "
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="d-flex gap-2 align-items-center">
                                <i className="mdi mdi-file-document-multiple fs-5 text-warning"></i>
                                <span className="font-weight-bold">
                                  {data.filename}
                                </span>
                              </div>
                              <div>
                                <i
                                  className="mdi mdi-eye fs-5 text-warning cursor-pointer"
                                  onClick={() => showLargeImage(data.path)}
                                  style={{ transition: "transform 0.3s" }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.transform =
                                      "scale(1.1)")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.transform =
                                      "scale(1)")
                                  }
                                ></i>
                              </div>
                            </div>

                            <div className="d-flex justify-content-between mt-2">
                              <div className="text-muted">
                                <strong>Category:</strong>{" "}
                                {data.media_category.replace(/_/g, " ")}
                              </div>
                              <div className="text-muted">
                                <strong>File Type:</strong> {data.file_type}
                              </div>
                            </div>

                            <div className="d-flex justify-content-between mt-2">
                              <div className="text-muted">
                                <strong>Media Type:</strong>{" "}
                                {data.media_type.replace(/_/g, " ")}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="text-center">
                <h5>No Documents Available</h5>
              </div>
            )}

            {openLightbox && (
              <Lightbox
                image={lightBoxViewImage}
                title="Image Title"
                onClose={() => setOpenLightBox(false)}
              />
            )}
          </div>
          </>
        
      )}
      </>
  );
 
};

export default FarmerDocuments;
